/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* basecomponent.ts
* 3-3-2020 - Jelmer Jellema - Spin in het Web B.V.
*
* Baseclass voor alle components in deze app. Abstract
*/

import {Sihwlog} from 'sihw-ngx';
import {ApiService} from '../services/api/api.service';
import {Subscription} from 'rxjs';
import {ChangeDetectorRef, Directive, inject} from '@angular/core';

@Directive() //nodig want classes met ng-events of angular decorators moeten gedecoreerd zin
export abstract class BaseComponent {
  //ook hier een static id-doorteller à la windowedcomponent. Zie id(...)
  static nextId = 0;
  private myId = ++(BaseComponent.nextId);

  protected log: Sihwlog;
  public api: ApiService = inject(ApiService); //public, zodat props als api.uid beschikbaar zijn in templates
  /**
   * Change detection helper voor OnPush: forceren van hertekenen na async updates in subklassen.
   */
  protected readonly cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  
  private subscriptions: Subscription = null; //lijst met subscriptions om te destroyen bij sluiten scherm
  //helpers met timing
  protected timing: number[] = [];

  protected constructor(loglevel: string = "warn")
  {
    //we maken hier met de injector alle standaardservices. Puur omdat constructor-inheritance niet
    //goed samengaat met DI
    this.log = new Sihwlog(loglevel, this.constructor.name);
    this.log.debug(`construct`,this.constructor.name);
  }

  ngOnDestroy() {
    //verwijder lopende subscriptions
    this.log.debug(`ngOnDestroy`, this.constructor.name);
    if (this.subscriptions) {
      this.log.debug(`Verwijderen subscriptions`);
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * Voeg een subscription toe aan dit object, wordt automatisch verwijderd bij destroy
   * @param sub
   */
  protected subscription(sub: Subscription) {
    if (this.subscriptions) {
      this.subscriptions.add(sub);
    } else {
      this.subscriptions = sub;
    }
  }

  /**
   * Start een nieuwe timer in debugmode
   * @protected
   */
  protected pushtimer() {
    if (this.log.effectiveLoglevel !== 'debug') {
      return;
    }
    this.timing.push(Date.now()); //bewaar deze timer
  }

  /**
   * Pop de timer en debug de tijd met het tijdsverschil
   * @param msg
   * @private
   */
  protected poptimer(msg: string) {
    if (this.log.effectiveLoglevel !== 'debug') {
      return;
    }
    let begin = this.timing.pop();
    let tijd = (Date.now() - begin) / 1000;
    if (tijd < 0.5) {
      this.log.debug(`*** TIMER ${msg}: ${tijd}`);
    } else {
      this.log.debug(`*** TIMER ${msg}: ${tijd}`);
    }
  }

  ////////////////////// ID HELPER ///////////////////////

  /**
   * Maak een uniek id in forms e.d. id('kleur') wordt bijvoorbeeld materieelEdit_3_kleur
   * @param idtag
   */
  public id(idtag): string {
    return `${this.constructor.name}_${this.myId}_${idtag}`;
  }
}
